import { EntityForm } from '@/common/entityFramework/entityForm/EntityForm';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useState } from 'react';
import { ProdPriceDate } from './formFields/ProdPriceDate';
import { ProdPricePeriodSelect } from './formFields/ProdPricePeriodSelect';
import { ProdPriceProgSelect } from './formFields/ProdPriceProgSelect';

export const ProdPriceForm = () => {
  const rsrc = useRsrc();
  const [priceTypeToPeriodicity, setPriceTypeToPeriodicity] = useState(null);

  // Retrieve the map of Price Type to periodicity
  useEffect(() => {
    rsrc.data('md', 'PROD_PRICE_FORM_PRICE_TYPE_ENUM_DATA_PLUGIN', {}).then( res => {
      setPriceTypeToPeriodicity(res);
    });
  }, []);

  if (!priceTypeToPeriodicity) {
    return <></>
  }
  
  const augFieldDefs = (fieldToFieldDef) => {
    fieldToFieldDef.progId.component = <ProdPriceProgSelect fieldDef={fieldToFieldDef.progId}/>;
    fieldToFieldDef.periodId.component = <ProdPricePeriodSelect priceTypeToPeriodicity={priceTypeToPeriodicity} fieldDef={fieldToFieldDef.periodId} />;
    fieldToFieldDef.startDate.component = <ProdPriceDate priceTypeToPeriodicity={priceTypeToPeriodicity} fieldDef={fieldToFieldDef.startDate} />;
    fieldToFieldDef.endDate.component = <ProdPriceDate priceTypeToPeriodicity={priceTypeToPeriodicity} fieldDef={fieldToFieldDef.endDate} />;
  }

  return (
    <EntityForm augFieldDefs={augFieldDefs}/>
  )
}